export default __webpack_public_path__ + "static/media/after_home.00ce1cde.webp";